/**
 * ⚠️ (v0.19.25 · 批 43c) 唯一实现已移到 js/src/common/InfiniteScroll.js
 *    本文件保留为 re-export, **只为不破坏 4 个 forum 子类的 import 路径** ⇒ 那 4 个文件零改动。
 *    ⛔ 不要在这里再放任何实现代码。
 *
 * ⚠️ 为什么是「先 import 再 export」两段式, 而不是一行「从 common 直接再导出」:
 *   flarum-webpack-config 的 autoExportLoader 会把那种一行写法**改写**成
 *   `import { default } from '...'` —— 那是**非法语法** ⇒ webpack 直接报
 *   "Module parse failed: Unexpected keyword 'default'"(本批 build 实测踩到)。
 *   ⇒ 两段式的导出内容与它**完全等价**(default + withInfiniteScroll), 模块路径也一模一样。
 */
import InfiniteScrollBase from '../../common/InfiniteScroll';
import { withInfiniteScroll } from '../../common/InfiniteScroll';
export default InfiniteScrollBase;
export { withInfiniteScroll };
flarum.reg.add('ziiven-ziven-scheduler', 'forum/utils/InfiniteScroll', InfiniteScrollBase);